import { render, staticRenderFns } from "./InventoryRequest.vue?vue&type=template&id=f8a2846e&scoped=true"
import script from "./InventoryRequest.vue?vue&type=script&lang=js"
export * from "./InventoryRequest.vue?vue&type=script&lang=js"
import style0 from "./InventoryRequest.vue?vue&type=style&index=0&id=f8a2846e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a2846e",
  null
  
)

export default component.exports